// eslint-disable-next-line import/prefer-default-export
export const activeFilters = (validFilters, currentFilters) => {
  if (!validFilters || !currentFilters) return false

  let hasFilters = false

  validFilters.forEach((filter) => {
    const currentFilter = currentFilters[filter]

    if (currentFilter) {
      const isString = typeof currentFilter === 'string'
      const isArrayNotEmprt =
        typeof Array.isArray(currentFilter) && currentFilter.length > 0

      if (isString || isArrayNotEmprt) {
        hasFilters = true
      }
    }
  })

  return hasFilters
}
